import { useCallback, useEffect, useMemo, useState } from "react";

import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  getBinsFromVolume,
  getWorkingRoutesNodes,
  postDownloadBinFromVolume,
} from "../../../../redux/api/expedition.api";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import {
  clearWorkingRoutesNodes,
  closeDownloadBinModal,
} from "../../../../redux/reducer/expedition.reducer";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import Dropdown, { DropdownValue } from "../../../../components/misc/Dropdown";
import Text from "../../../../styleguide/Text";
import { dateAndTimeForDatabase } from "../../../../utils/dateAndTime";
import DateTimePicker from "../../../../components/misc/DateTimePicker";

function DownloadBinFromVolumeModal() {
  const { routeParams, routeMainParam } = useRoutesHelper();

  const { nrVolum } = routeMainParam;

  const dispatch = useAppDispatch();

  const {
    expedition: {
      workingRoutesNodes: {
        data: { data: workingNodes },
      },
      isDownloadBinModalOpen,
      selectedBinFromVolume,
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(
      getWorkingRoutesNodes({
        page: 1,
        perPage: 1000,
      }),
    );
  }, [dispatch]);

  const [selectedNode, setSelectedNode] = useState<DropdownValue | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  useEffect(() => {
    return () => {
      dispatch(clearWorkingRoutesNodes());
    };
  }, [dispatch]);

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (!selectedBinFromVolume || !selectedNode) {
        return;
      }
      setIsLoading(true);

      const resultAction = await dispatch(
        postDownloadBinFromVolume({
          id_nod: selectedNode.id,
          id_bin: selectedBinFromVolume.id_bin,
          data_descarcare: dateAndTimeForDatabase(selectedDate),
        }),
      );

      if (
        checkEndpointStatus(resultAction, postDownloadBinFromVolume) !==
        endpointStatus.pending
      ) {
        setIsLoading(false);
      }

      if (
        checkEndpointStatus(resultAction, postDownloadBinFromVolume) ===
        endpointStatus.fulfilled
      ) {
        const { page } = routeParams;

        dispatch(
          getBinsFromVolume({
            page: page,
            per_page: 9999,
            nrVolum: nrVolum,
          }),
        );

        setSelectedNode(null);
        dispatch(closeDownloadBinModal());
        handleClose && handleClose();
      }
    },
    [
      dispatch,
      nrVolum,
      routeParams,
      selectedBinFromVolume,
      selectedDate,
      selectedNode,
    ],
  );

  const workingNodesDropdownValues = useMemo(
    () =>
      workingNodes?.map((item) => ({
        label: item.nodNume,
        id: item.id_nod,
      })),
    [workingNodes],
  );

  const handleSelectValue = (value: any) => {
    setSelectedNode(value);
  };

  const isSubmitDisabled =
    !selectedNode?.id || !selectedBinFromVolume?.id_bin || !selectedDate;

  const onClose = useCallback(() => {
    dispatch(closeDownloadBinModal());
    setSelectedNode(null);
    setSelectedDate(null);
  }, [dispatch]);

  return (
    <>
      <ModalWrapper
        show={!!isDownloadBinModalOpen}
        title="Descarcare bin"
        modalSize="md"
        handleClose={onClose}>
        <div className="flex flex-col">
          <Dropdown
            title="Cauta nodul"
            className=""
            data={workingNodesDropdownValues}
            singleValue={selectedNode}
            setSingleValue={handleSelectValue}
          />

          <DateTimePicker
            label="Data si ora descarcarii"
            value={selectedDate}
            handleChangeDate={(newDate) => setSelectedDate(newDate)}
          />
        </div>

        <CustomButton
          type="submit"
          variant="contained"
          fullWidth
          className="mt-5 w-full"
          disabled={isSubmitDisabled}
          loading={isLoading}
          onClick={handleOnSubmit}>
          <Text variant="body1" isBold>
            Salveaza
          </Text>
        </CustomButton>
      </ModalWrapper>
    </>
  );
}

export default DownloadBinFromVolumeModal;
